import React from 'react';
import { Instagram, Heart } from 'lucide-react';
import { brandInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black text-white py-12">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <img 
              src={brandInfo.logo} 
              alt={brandInfo.name}
              className="h-16 w-auto mb-4 brightness-0 invert"
            />
            <p className="body-medium-custom text-white">
              {brandInfo.tagline}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="card-heading-custom mb-4 text-white">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a href="#home" className="nav-link text-white hover:text-gray-300">
                  Home
                </a>
              </li>
              <li>
                <a href="#gallery" className="nav-link text-white hover:text-gray-300">
                  Gallery
                </a>
              </li>
              <li>
                <a href="#pricing" className="nav-link text-white hover:text-gray-300">
                  Pricing
                </a>
              </li>
              <li>
                <a href="#contact" className="nav-link text-white hover:text-gray-300">
                  Contact
                </a>
              </li>
              <li>
                <a 
                  href={`mailto:${brandInfo.email}`}
                  className="nav-link text-white hover:text-gray-300"
                >
                  {brandInfo.email}
                </a>
              </li>
              <li>
                <a 
                  href="/inquiries"
                  className="nav-link text-yellow-400 hover:text-yellow-300 font-semibold"
                >
                  📋 View Customer Inquiries
                </a>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div>
            <h3 className="card-heading-custom mb-4 text-white">Follow Us</h3>
            <div className="space-y-3">
              <a
                href={brandInfo.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-white hover:text-gray-300 transition-colors"
              >
                <Instagram size={20} />
                <span>@triansh_arts</span>
              </a>
              <a
                href={brandInfo.sisterInstagram}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-yellow-400 hover:text-yellow-300 transition-colors"
              >
                <Instagram size={20} />
                <span>@sketchrally.co</span>
              </a>
            </div>
            
            <div className="mt-6">
              <h3 className="card-heading-custom mb-3 text-white text-sm">More Paintings</h3>
              <a
                href={brandInfo.sisterWebsite}
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-yellow-400 transition-colors text-sm underline"
              >
                sketchrallyco.oodo.com
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="body-small-custom text-white">
              © {currentYear} {brandInfo.name}. All rights reserved.
            </p>
            <p className="body-small-custom text-white flex items-center gap-2">
              Made with <Heart size={16} className="text-red-500" /> for art lovers
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
